import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface AccessTokenState {
  value: string | null;
}

const initialState: AccessTokenState = { value: null };

export const accessTokenSlice = createSlice({
  name: 'AccessToken',
  initialState,
  reducers: {
    setAcessToken: (state: AccessTokenState, action: PayloadAction<string | null>) => {
      state.value = action.payload;
    },
  },
});

export const selectedAccessToken = (state: RootState) => state.accessToken.value;

export const { setAcessToken } = accessTokenSlice.actions;

export default accessTokenSlice.reducer;
